var _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 50,
    viewBox: "0 0 135 50",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "0.0, 41.7713868743246 15.0, 47.200962534674645 30.0, 36.35295166159776 45.0, 39.54190479373462 60.0, 50.0 75.0, 47.618729320544084 90.0, 33.693169791562234 105.0, 0.0 120.0, 0.8288493031650258",
    fill: "none",
    stroke: "#32ca5b",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark2);
export default __webpack_public_path__ + "static/media/spark2.e0e64f82eac47e25ff9de9c117127c11.svg";
export { ForwardRef as ReactComponent };